import { usePageTelemetryContext } from './usePageTelemetryContext';

export const usePageTelemetryContextSetRouteCallback = () => usePageTelemetryContext()?.setRoute;
